import { useMarkStationeryTemplateAsFavoriteMutation, useUnmarkStationeryTemplateAsFavoriteMutation } from './useFavoriting.graphql.generated';
import { useEffect, useState } from 'react';
import { useApolloClient } from '@apollo/client';

interface UseFavoritingProps {
  isFavorite: boolean;
  templateId: string;
  eventId: string;
}

const useFavoriting = ({ isFavorite: initialIsFavorite, templateId, eventId }: UseFavoritingProps) => {
  const [isFavorite, setIsFavorite] = useState(initialIsFavorite);
  const client = useApolloClient();

  const [markTemplateAsFavorite, { loading: isMarkingAsFavorite }] = useMarkStationeryTemplateAsFavoriteMutation();
  const [unmarkTemplateAsFavorite, { loading: isUnmarkingAsFavorite }] = useUnmarkStationeryTemplateAsFavoriteMutation();

  useEffect(() => {
    setIsFavorite(initialIsFavorite);
  }, [initialIsFavorite]);

  const evictStationeryCache = () => {
    client.cache.evict({ fieldName: 'stationeryDraftsByEvent' });
    client.cache.evict({ fieldName: 'stationeryPrintOrdersByEvent' });
    client.cache.evict({ fieldName: 'getMostRecentEcardByEventId' });
    client.cache.evict({ fieldName: 'stationeryTemplatesContainer' });
    client.cache.gc();
  };

  const toggleFavorite = async () => {
    if (!eventId) {
      return;
    }

    if (isFavorite) {
      setIsFavorite(false);
      await unmarkTemplateAsFavorite({ variables: { templateId, eventId } });
    } else {
      setIsFavorite(true);
      await markTemplateAsFavorite({ variables: { templateId, eventId } });
    }

    evictStationeryCache();
  };

  return { isFavorite, toggleFavorite, isLoading: isMarkingAsFavorite || isUnmarkingAsFavorite };
};

export default useFavoriting;
